module.exports = __webpack_public_path__ + "img/7cf35db.png";